const emptySolutions = [
    {
        height: 201,
        depth: 35,
        width: 50,
        vpc: 'HYJGLK'
    },
    {
        height: 236,
        depth: 35,
        width: 50,
        vpc: 'HYJGNP'
    },
    {
        height: 236,
        depth: 58,
        width: 50,
        vpc: 'HYJGQ8'
    },
    {
        height: 201,
        depth: 58,
        width: 50,
        vpc: 'HYJGRW'
    },
    {
        height: 201,
        depth: 35,
        width: 75,
        vpc: 'HYJH25'
    },
    {
        height: 236,
        depth: 35,
        width: 75,
        vpc: 'HYJGZ4'
    },
    {
        height: 236,
        depth: 58,
        width: 75,
        vpc: 'HYJGWG'
    },
    {
        height: 201,
        depth: 58,
        width: 75,
        vpc: 'HYJGTS'
    },
    {
        height: 201,
        depth: 35,
        width: 100,
        vpc: 'HYJH3P'
    },
    {
        height: 236,
        depth: 35,
        width: 100,
        vpc: 'HYJH4Z'
    },
    {
        height: 236,
        depth: 58,
        width: 100,
        vpc: 'HYJH6H'
    },
    {
        height: 201,
        depth: 58,
        width: 100,
        vpc: 'HYJH7L'
    },
    {
        height: 201,
        depth: 35,
        width: 125,
        vpc: 'HYJHD3'
    },
    {
        height: 236,
        depth: 35,
        width: 125,
        vpc: 'HYJHFD'
    },
    {
        height: 236,
        depth: 58,
        width: 125,
        vpc: 'HYJHH3'
    },
    {
        height: 201,
        depth: 58,
        width: 125,
        vpc: 'HYJHJ6'
    },
    {
        height: 201,
        depth: 35,
        width: 150,
        vpc: 'J25BSG',
        slidingDoor: 'HYJHNR'
    },
    {
        height: 236,
        depth: 35,
        width: 150,
        vpc: 'J25C2V',
        slidingDoor: 'HYJHPV'
    },
    {
        height: 236,
        depth: 58,
        width: 150,
        vpc: 'J25C5W',
        slidingDoor: 'HYJHQV'
    },
    {
        height: 201,
        depth: 58,
        width: 150,
        vpc: 'J25CC4',
        slidingDoor: 'HYJHSL'
    },
    {
        height: 201,
        depth: 35,
        width: 175,
        vpc: 'HYJJ5V'
    },
    {
        height: 236,
        depth: 35,
        width: 175,
        vpc: 'HYJJ6W'
    },
    {
        height: 236,
        depth: 58,
        width: 175,
        vpc: 'HYJJ7V'
    },
    {
        height: 201,
        depth: 58,
        width: 175,
        vpc: 'HYJJ94'
    },
    {
        height: 201,
        depth: 35,
        width: 200,
        vpc: 'HYJJDS',
        slidingDoor: 'HYJJDS'
    },
    {
        height: 236,
        depth: 35,
        width: 200,
        vpc: 'HYJJG2',
        slidingDoor: 'HYJJG2'
    },
    {
        height: 236,
        depth: 58,
        width: 200,
        vpc: 'HYJJGN',
        slidingDoor: 'HYJJGN'
    },
    {
        height: 201,
        depth: 58,
        width: 200,
        vpc: 'HYJJHR',
        slidingDoor: 'HYJJHR'
    },
    {
        height: 201,
        depth: 35,
        width: 225,
        vpc: 'HYJJRN'
    },
    {
        height: 236,
        depth: 35,
        width: 225,
        vpc: 'HYJJT9'
    },
    {
        height: 236,
        depth: 58,
        width: 225,
        vpc: 'HYJJVB'
    },
    {
        height: 201,
        depth: 58,
        width: 225,
        vpc: 'HYJJWG'
    },
    {
        height: 201,
        depth: 35,
        width: 250,
        vpc: 'HYJK3F'
    },
    {
        height: 236,
        depth: 35,
        width: 250,
        vpc: 'HYJK56'
    },
    {
        height: 236,
        depth: 58,
        width: 250,
        vpc: 'HYJK64'
    },
    {
        height: 201,
        depth: 58,
        width: 250,
        vpc: 'HYJK6P'
    },
    {
        height: 201,
        depth: 35,
        width: 275,
        vpc: 'HYJK92'
    },
    {
        height: 236,
        depth: 35,
        width: 275,
        vpc: 'HYJKB4'
    },
    {
        height: 236,
        depth: 58,
        width: 275,
        vpc: 'HYJKBR'
    },
    {
        height: 201,
        depth: 58,
        width: 275,
        vpc: 'HYJKCN'
    },
    {
        height: 201,
        depth: 35,
        width: 300,
        vpc: 'HYJKHG',
        slidingDoor: 'HYJL6K'
    },
    {
        height: 236,
        depth: 35,
        width: 300,
        vpc: 'HYJKJS',
        slidingDoor: 'HYJL8R'
    },
    {
        height: 236,
        depth: 58,
        width: 300,
        vpc: 'HYJKL2',
        slidingDoor: 'HYJLB7'
    },
    {
        height: 201,
        depth: 58,
        width: 300,
        vpc: 'HYJKLZ',
        slidingDoor: 'HYJLCG'
    },
    {
        height: 201,
        depth: 35,
        width: 325,
        vpc: 'HYJKP7'
    },
    {
        height: 236,
        depth: 35,
        width: 325,
        vpc: 'HYJKQS'
    },
    {
        height: 236,
        depth: 58,
        width: 325,
        vpc: 'HYJKRW'
    },
    {
        height: 201,
        depth: 58,
        width: 325,
        vpc: 'HYJKSQ'
    },
    {
        height: 201,
        depth: 35,
        width: 350,
        vpc: 'HYJMJ2',
        slidingDoor: 'HYJMP5'
    },
    {
        height: 236,
        depth: 35,
        width: 350,
        vpc: 'HYJMK9',
        slidingDoor: 'HYJMQQ'
    },
    {
        height: 236,
        depth: 58,
        width: 350,
        vpc: 'HYJML9',
        slidingDoor: 'HYJMRN'
    },
    {
        height: 201,
        depth: 58,
        width: 350,
        vpc: 'HYJMM4',
        slidingDoor: 'HYJMT8'
    },
    {
        height: 201,
        depth: 35,
        width: 375,
        vpc: 'HYJMW7'
    },
    {
        height: 236,
        depth: 35,
        width: 375,
        vpc: 'HYJMY8'
    },
    {
        height: 236,
        depth: 58,
        width: 375,
        vpc: 'HYJMZ6'
    },
    {
        height: 201,
        depth: 58,
        width: 375,
        vpc: 'HYJMSR'
    },
    {
        height: 201,
        depth: 35,
        width: 400,
        vpc: 'HYJMP6',
        slidingDoor: 'HYJMP6'
    },
    {
        height: 236,
        depth: 35,
        width: 400,
        vpc: 'HYJMMD',
        slidingDoor: 'HYJMMD'
    },
    {
        height: 236,
        depth: 58,
        width: 400,
        vpc: 'HYJMJK',
        slidingDoor: 'HYJMJK'
    },
    {
        height: 201,
        depth: 58,
        width: 400,
        vpc: 'HYJMQR',
        slidingDoor: 'HYJMQR'
    },
    {
        height: 201,
        depth: 35,
        width: 425,
        vpc: 'HYJM99'
    },
    {
        height: 236,
        depth: 35,
        width: 425,
        vpc: 'HYJM78'
    },
    {
        height: 236,
        depth: 58,
        width: 425,
        vpc: 'HYJMDF'
    },
    {
        height: 201,
        depth: 58,
        width: 425,
        vpc: 'HYJMC8'
    },
    {
        height: 201,
        depth: 35,
        width: 450,
        vpc: 'HYJM3T',
        slidingDoor: 'HYJNZ9'
    },
    {
        height: 236,
        depth: 35,
        width: 450,
        vpc: 'HYJM58',
        slidingDoor: 'HYJP26'
    },
    {
        height: 236,
        depth: 58,
        width: 450,
        vpc: 'HYJLVN',
        slidingDoor: 'HYJNM5'
    },
    {
        height: 201,
        depth: 58,
        width: 450,
        vpc: 'HYJLZV',
        slidingDoor: 'HYJNYF'
    }
];
export default emptySolutions;
//# sourceMappingURL=emptySolutions.js.map